import { render, staticRenderFns } from "./login_page.vue?vue&type=template&id=95272ad2"
import script from "./login_page.vue?vue&type=script&lang=js"
export * from "./login_page.vue?vue&type=script&lang=js"
import style0 from "./login_page.vue?vue&type=style&index=0&id=95272ad2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports